import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Redirect from Vercel to Cloudflare Pages
if (window.location.hostname === 'universo-acessivel.vercel.app') {
  window.location.replace('https://universo-acessivel.pages.dev' + window.location.pathname + window.location.search + window.location.hash);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
